
  import {Component, Vue} from "vue-property-decorator";
  import MyList from "@/components/myList.vue";
  import {getConfig, getModelConfig, saveDomainConfig, saveLangdingPage} from '@/services/api'
  import store from "@/store";
  import validator from "@/services/validatorNew";


  @Component({
    components: {'my-list': MyList},
  })
  export default class DomainEdit extends Vue{

    // 域名列表
    public domainList: {domain: string, pixel: string, path: string}[] = []
    // 模版列表
    public templateList: {templateId: number, templateName: string}[] = [{
      "templateId": 0,
      "templateName": "请选择模板"
    }]

    // 表单信息
    public formData: {
      domain?: string,
      // pixel?: string,
      // pixelGG?: string,
      // path?: string,
      templateId?: number,
      templateName?: string,
      // itemIds: any[],
      [props: string]: any
    } = {
      domain: "",
      templateId: 0,
      templateName: ""
    }

    // 验证规则
    private rules: {[key: string]:{required: boolean, requiredMsg?: string, reg?: RegExp, regMsg?: string, max?: number, maxMsg?: string, min?: number, minMsg?: string}}= {
      domain: {required: true, requiredMsg: '投放域名不能为空'},
    }

    // 选择框展示
    public dialogVisible = false;

    /**
     * 初始化方法
     */
    created() {
      this.getConfig();
    }

    /**
     * 获取字典信息
     */
    getConfig(): void {
      if (!this.$store.state.domain || this.$store.state.domain.length === 0) {
        getConfig({type: 'domain'}).then(res => {
          if (res.data && res.data.status === 'OK') {
            this.domainList = res.data.result || [];
            store.commit('SET_DOMAIN', this.domainList);
          }
        })
      } else {
        this.domainList = this.$store.state.domain;
      }
      getModelConfig().then(res => {
        if (res.data) {
          let result = []
          let c = this.templateList
          for (const dataKey in res.data.data) {
            result.push({
              "templateId": res.data.data[dataKey].id,
              "templateName": res.data.data[dataKey].configName
            })
          }
          this.templateList = c.concat(result);
        }
      })
    }

    /**
     * 上传
     */
    submit() {
      if(!this.checkForm()) {
        return;
      }
      for (let domain of this.domainList) {
        if (this.formData.domain === domain.domain) {
          this.formData.path = domain.path;
          // this.formData.pixel = domain.pixel;
        }
      }
      for (let template of this.templateList) {
        if (this.formData.templateId === template.templateId) {
          this.formData.templateName = template.templateName;
        }
      }
      saveDomainConfig(this.formData, true).then(res => {
        if (res.data && res.data.status === 'OK') {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.data.body.message);
        }
      }).catch(() => {})
    }

    /**
     * 校验表单内容是否通过
     */
    checkForm(): boolean {
      for (let key of Object.keys(this.rules)) {
        if(!validator(this.rules[key], this.formData[key], (msg: string) => {
          this.$message.error(msg);
        })) {
          return false;
        }
      }
      return true;
    }

    /**
     * 关闭选择框
     */
    handleClose(): void {
      this.dialogVisible = false;
    }
  }
